import React from 'react';

const DocumentIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none">
            <rect width="67" height="67" fill="#F5F5F5" />
            <mask id="mask0_2569_4692" maskUnits="userSpaceOnUse" x="9" y="10" width="48" height="48">
                <rect x="9" y="10" width="48" height="48" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2569_4692)">
                <path
                    d="M25 35H41V32H25V35ZM25 41H41V38H25V41ZM25 47H35V44H25V47ZM20 54C19.2 54 18.5 53.7 17.9 53.1C17.3 52.5 17 51.8 17 51V17C17 16.2 17.3 15.5 17.9 14.9C18.5 14.3 19.2 14 20 14H38.05L49 24.95V51C49 51.8 48.7 52.5 48.1 53.1C47.5 53.7 46.8 54 46 54H20ZM36.55 26.3V17H20V51H46V26.3H36.55Z"
                    fill="#C4C4C4"
                />
            </g>
        </svg>
    );
};

export default DocumentIcon;
